import React from 'react'
import { FilterTag } from './FilterTag'
import { useTranslation } from 'react-i18next'
import { StClearAllButton, StFilterTagList } from './styles'

export const FilterTagList = ({ filterValues, onRemove, clearAll, inGrid = true }) => {
  const { t } = useTranslation('productFilter')

  return (
    <StFilterTagList inGrid={inGrid}>
      {filterValues.map((value, index) => (
        <FilterTag key={value + index} tagLabel={value} onRemove={() => onRemove(value)} />
      ))}
      {filterValues.length > 1 ? (
        <StClearAllButton onClick={() => clearAll()}>
          {t('productFilters.clearAll')}
        </StClearAllButton>
      ) : null}
    </StFilterTagList>
  )
}
